import { useEffect, useMemo, useState } from 'react';
import useBreakpoints from '../../../../../common/hooks/useBreakpoints';
import Icons from '../../../../../common/widgets/Icons';
import Loader from '../../../../../common/widgets/Loader';
import LoadingSpinner from '../../../../../common/widgets/LoadingSpinner';
import { DyPageTypeEnum, TopLevelCategories } from '../../../enums';
import { Category, CategoryDetails } from '../../../models/Categories';
import { categoryService } from '../../../services/category';
import BenefitBucksWallet from '../../CategoryPage/Components/BenefitBucks';
import CategoryListItem from '../../Common/CategoryListItem';
import MostPopularProducts from '../../Common/MostPopularProducts';
import RecommendedProducts from '../../Common/RecommendedProducts';
import TopDiscountedProducts from '../../Common/TopDiscountedProducts';

interface BenefitsPanelProps {
  topLevelCategoryId: number | undefined;
  categories?: Category[];
  title?: string;
}

export default function BenefitsPanel(props: Readonly<BenefitsPanelProps>) {
  const { topLevelCategoryId, categories, title } = props;
  const { isTablet } = useBreakpoints();

  const [currentCategoryDetails, setCurrentCategoryDetails] = useState<
    CategoryDetails | undefined
  >();

  const dyCategoryPageData = useMemo(
    () => ({
      topLevelCategoryId: topLevelCategoryId!,
      categoryId: topLevelCategoryId!,
    }),
    [topLevelCategoryId],
  );

  useEffect(() => {
    setCurrentCategoryDetails(undefined);
    if (topLevelCategoryId === TopLevelCategories.Cashback)
      loadCategoryDetails();
  }, [topLevelCategoryId]);

  const loadCategoryDetails = async () => {
    setCurrentCategoryDetails(undefined);
    const result = await categoryService.getCategoryDetails(
      Number(TopLevelCategories.Cashback),
    );

    if (!result.hasErrors) {
      setCurrentCategoryDetails({ ...result.data });
    }
  };

  return (
    <>
      {!isTablet && <h1>{title}</h1>}
      {currentCategoryDetails?.showBenefitBucksWallet && <BenefitBucksWallet />}
      <Loader loading={!categories} loader={<LoadingSpinner />}>
        <section className="page-section">
          <div className="card-list card-list-5 card-list-lg-4 card-list-sm-3 card-list-xs-2">
            {categories
              ?.filter(category => !category.isSaveEveryday)
              .map(category => (
                <CategoryListItem
                  key={category.id}
                  category={category}
                ></CategoryListItem>
              ))}
          </div>
        </section>
        <RecommendedProducts
          pageType={DyPageTypeEnum.Category}
          categoryPageData={dyCategoryPageData}
        />
        {topLevelCategoryId !== TopLevelCategories.Cashback && (
          <>
            <MostPopularProducts
              categoryId={topLevelCategoryId}
              showBrands={true}
            />
            <TopDiscountedProducts categoryId={topLevelCategoryId} />
          </>
        )}
      </Loader>
      {!!currentCategoryDetails?.description.length && (
        <div id="category-description" className="category-description">
          <Icons.Info />
          <div
            dangerouslySetInnerHTML={{
              __html: currentCategoryDetails?.description || '<></>',
            }}
          ></div>
        </div>
      )}
    </>
  );
}
